module.exports = __webpack_public_path__ + "static/media/Lacapital-Studio-Option1-Cam-03-1-.e90b67ed.webp";